export default __webpack_public_path__ + "static/premio-pe-fdde6d72e81ad762d5a5579ecce785e4.png";